import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const NavButton = ({ categorie, setCategories }) => {
  console.log('categorie :>> ', categorie);
  const { t } = useTranslation();
  return (
    <header className="categories">
      <StyledButton
        categorie={categorie}
        item={""}
        onClick={() => setCategories("")}
      >
        {t("projectDescription.all")}
      </StyledButton>
      <StyledButton
        categorie={categorie}
        item={"React"}
        onClick={() => setCategories("React")}
      >
        React
      </StyledButton>
      <StyledButton
        categorie={categorie}
        item={"Redux"}
        onClick={() => setCategories("Redux")}
      >
        Redux
      </StyledButton>
      <StyledButton
        categorie={categorie}
        item={"Node"}
        onClick={() => setCategories("Node")}
      >
        Node
      </StyledButton>
      <StyledButton
        categorie={categorie}
        item={"SASS"}
        onClick={() => setCategories("SASS")}
      >
        SASS
      </StyledButton>
      <StyledButton
        categorie={categorie}
        item={"Stripe"}
        onClick={() => setCategories("Stripe")}
      >
        Stripe
      </StyledButton>
      <StyledButton
        categorie={categorie}
        item={"Rest"}
        className="opacity"
        onClick={() => setCategories("API")}
      >
        Rest API
      </StyledButton>
      <StyledButton
        categorie={categorie}
        item={"Axios"}
        className="opacity"
        onClick={() => setCategories("Axios")}
      >
        Axios
      </StyledButton>
      <StyledButton
        categorie={categorie}
        item={"Games"}
        className="opacity"
        onClick={() => setCategories("Games")}
      >
        {t("projectDescription.game")}
      </StyledButton>
    </header>
  );
};

const StyledButton = styled.button`
  background-color: ${({ categorie, item }) =>
    categorie === item ? "white" : "#AFD5ED"};
  color: ${({ categorie, item }) => (categorie !== item ? "white" : "#AFD5ED")};
`;

export default NavButton;
